module.exports = __webpack_public_path__ + "static/img/home-main-poster.056e01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home-main-poster.jpg
// module id = RYSf
// module chunks = 1